import script from "./FooterLicense.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLicense.vue?vue&type=script&setup=true&lang=js"

import "./FooterLicense.vue?vue&type=style&index=0&id=780e39ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780e39ae"]])

export default __exports__